import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Form,
  Input,
  message,
  Row,
  Space,
  Switch,
} from "antd";
import React, { useEffect } from "react";
import { updateAdminSetting } from "../../api/SettingApi";

export default function SettingTab({ adminSetting, fetchSettings }) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(adminSetting);
  }, [adminSetting]);

  const saveSection = async () => {
    try {
      const values = await form.validateFields();
      await updateAdminSetting(values);
      fetchSettings();
      message.success("System settings saved");
    } catch {
      message.error("Validation failed");
    }
  };

  return (
    <>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card title="System Configuration">
              <Row align="middle" gutter={[16, 12]}>
                {/* API Timeout */}
                <Col span={24}>
                  <Form.Item
                    name="apiTimeout"
                    label="API Timeout (seconds)"
                    rules={[{ required: true, message: "Enter timeout" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="sessionTimeout"
                    label="Session Timeout (minutes)"
                    rules={[{ required: true, message: "Enter timeout" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Divider style={{ margin: "8px 0" }} />
                </Col>

                {/* Maintenance Mode */}
                <Col xs={18} sm={20}>
                  <div style={{ fontWeight: 300 }}>Maintenance Mode</div>
                </Col>
                <Col xs={6} sm={4}>
                  <Form.Item
                    name="maintenanceMode"
                    valuePropName="checked"
                    style={{ margin: 0 }}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Divider style={{ margin: "8px 0" }} />
                </Col>

                {/* Debug Mode */}
                <Col xs={18} sm={20}>
                  <div style={{ fontWeight: 300 }}>Debug Mode</div>
                </Col>
                <Col xs={6} sm={4}>
                  <Form.Item
                    name="debugMode"
                    valuePropName="checked"
                    style={{ margin: 0 }}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Divider style={{ margin: "8px 0" }} />
                </Col>

                {/* Save button */}
                <Col span={24}>
                  <Button type="primary" onClick={saveSection}>
                    Save System Settings
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card title="System Information">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="System Version">
                  v2.1.0
                </Descriptions.Item>
                <Descriptions.Item label="Database Status">
                  <Space>
                    <span style={{ color: "green" }}>●</span> Online
                  </Space>
                </Descriptions.Item>
                <Descriptions.Item label="Last Backup">
                  2024-01-20 02:00
                </Descriptions.Item>
                <Descriptions.Item label="Active Limits">
                  Transaction & Balance
                </Descriptions.Item>

                <Descriptions.Item label="Fee Types Configured">
                  Flat, Percentage, Tiered
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        </Row>
      </Form>
      {/* <Divider /> */}
    </>
  );
}
